import logo from '../../../white-logo.png';
import SidebarItem from "./SidebarItem";
import { useLocation } from 'react-router-dom';
import { FaChevronLeft, FaChevronRight, FaInfoCircle } from 'react-icons/fa';
import { useAuthDispatch, useAuthState } from '../../../context/AuthContext';
import { motion } from 'framer-motion';
import FeedbackBtn from './FeedbackBtn';

/**
 * ENERGO Sidebar
 * 
 * Sidebar navigation for MP
 * 
 * @param {Array} menuOptions array of objects with key (id, icon, text, link)
 * @param {boolean} toggleSidebar boolean to expand/collapse sidebar
 * @param {setter} setToggleSidebar setter to expand/collapse sidebar
 * @returns 
 */
const Sidebar = ({menuOptions, toggleSidebar, setToggleSidebar}) => {

    const { user } = useAuthState();
    const location = useLocation(); // url path to get active
    const {tooltipsTrigger} = useAuthState(); // tooltips active?
    const dispatch = useAuthDispatch(); // dispatch auth states

    // dispatch toggle on / off
    const toggleTooltips = () => {
        if (tooltipsTrigger === true) dispatch('TOOLTIPS_OFF');
        else dispatch('TOOLTIPS_ON');
    }

    return (
        <motion.div 
            className="sidebar" 
            style={toggleSidebar ? {width: 230} : {width: 60}}
            animate={{width: toggleSidebar ? 230 : 60}}
            transition={{duration: 0.3}}
        >
            <SidebarItem
                key="logo-sb"
                icon={<img height={30} src={logo} alt='' />}
                text={<b>ENERGO</b>}
                link="/hw/dashboard/"
                collapsed={!toggleSidebar}
                style={{paddingLeft:5, marginLeft:"auto", marginRight:"auto", marginTop:10, cursor: "pointer"}}
                noHover
            />
            <a
                className='text-center text-light'
                style={{marginLeft: "auto", marginRight: "auto", marginTop: 10, cursor: "pointer", padding: 0}}
                onClick={e => {e.preventDefault(); setToggleSidebar(!toggleSidebar)}}
            >
                {toggleSidebar === true ?
                    <FaChevronLeft size={22} /> :
                    <FaChevronRight size={22} /> 
                }
            </a>

            {menuOptions && menuOptions.length > 0 &&
                menuOptions.map(opt => (
                    <SidebarItem
                        key={opt.id}
                        icon={opt.icon}
                        text={opt.text}
                        link={opt.link}
                        collapsed={!toggleSidebar}
                        isActive={location.pathname === opt.link}
                    />
            ))}

            <div className="bottom">
                <a 
                    href="tooltips/"
                    onClick={e => {e.preventDefault(); toggleTooltips()}}
                    className={tooltipsTrigger !== undefined && tooltipsTrigger === true ?
                        "text-warning glow-effect" : 'text-light'
                    }
                >
                    <FaInfoCircle size={32} style={{marginTop:6, marginRight:10}} />
                </a>
                {user && user.x_is_house_management &&
                    <FeedbackBtn />
                }
            </div>
        </motion.div>
    )
}
export default Sidebar;